import { HttpClient } from '@angular/common/http';
import { AD_TO_USER_MAP, USER_ICON_MAP, } from '@models';
import { of } from 'rxjs';
import { map, mergeAll, toArray, } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DirectoryUrl = /** @class */ (function () {
    function DirectoryUrl() {
    }
    Object.defineProperty(DirectoryUrl, "getDomains", {
        get: function () { return "/api/DirectoryService/GetDomains"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DirectoryUrl, "getDirectoryPermissions", {
        get: function () { return "/api/DirectoryService/GetDirectoryPermissions"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DirectoryUrl, "searchForUsersAndGroups", {
        get: function () { return "/api/DirectoryService/SearchForUsersAndGroups"; },
        enumerable: true,
        configurable: true
    });
    return DirectoryUrl;
}());
export { DirectoryUrl };
export var SearchContext;
(function (SearchContext) {
    SearchContext[SearchContext["All"] = 0] = "All";
    SearchContext[SearchContext["Users"] = 1] = "Users";
    SearchContext[SearchContext["Groups"] = 2] = "Groups";
})(SearchContext || (SearchContext = {}));
var DirectoryService = /** @class */ (function () {
    function DirectoryService(_http) {
        var _this = this;
        this._http = _http;
        this.getDomains = function () { return _this._http
            .get(DirectoryUrl.getDomains); };
        this.searchForUsersAndGroups = function (domain, query, searchContext) { return _this._http
            .get(DirectoryUrl.searchForUsersAndGroups, {
            params: {
                domain: domain,
                prefix: encodeURIComponent(query),
                searchContext: SearchContext[searchContext],
            },
        }); };
    }
    DirectoryService.prototype.adSearchFactory = function (domain, query, searchContext) {
        if (searchContext === void 0) { searchContext = SearchContext.All; }
        if (!query || query.length < 2) {
            return of([]);
        }
        return this.searchForUsersAndGroups(domain, query, searchContext)
            .pipe(mergeAll(), map(function (result) {
            var userType = AD_TO_USER_MAP[result.type];
            return {
                id: result.identityName,
                text: result.displayName,
                type: userType,
                icon: USER_ICON_MAP[userType],
            };
        }), toArray(), map(function (results) { return ({
            total: results.length,
            data: results,
        }); }));
    };
    DirectoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DirectoryService_Factory() { return new DirectoryService(i0.ɵɵinject(i1.HttpClient)); }, token: DirectoryService, providedIn: "root" });
    return DirectoryService;
}());
export { DirectoryService };
